export default "__VITE_ASSET__hMBUpQTI__"